import { LayoutVertical, LoadingSpinner } from 'breeze-intelligence-kit';
import { BasePanel } from '../Panel/BasePanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function PanelLoading({
  children,
  isLoading
}) {
  if (isLoading) {
    return /*#__PURE__*/_jsx(BasePanel.Body, {
      children: /*#__PURE__*/_jsx(LayoutVertical, {
        alignItems: "center",
        blockSize: "100%",
        flexGrow: 1,
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          size: "md"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}